import React, { useRef, useState , useEffect} from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { API } from '../../../config/API';
import axios from 'axios';
import Loader from '../../../components/Loader/Loader';
import ToastComp from '../../../components/Toast/Toast';
import toast from 'react-hot-toast';

function AddUser(arg) {
  const [show, setShow] = useState(arg.flag);
  const [name,setName] = useState("");
  const [email, setEmail] = useState('');
  const [group, setGroup] = useState('');
  const [manager, setManager] = useState('');
  const [imageSource, setImageSource] = useState("");
  const [loader,setLoader] = useState(false);
  const [toastToggle, setToastToggle] = useState(false);
  const [errorToggle, setErrorToggle] = useState(false);
  const [username,setUsername] = useState('');
  const [level, setLevel] = useState('');
  const [project, setProject] = useState('');
  const [managerView , setManagerview] = useState(false);
  const [isFacilitator, setIsFacilitator] = useState(false);
  const [isCILead, setIsCILead] = useState(false);
  const profileImage = useRef('');
  const [departments, setDepartments] = useState([]);
  
  const levelData = arg.masterData.level;
  const projectData = arg.masterData.project;
  
  useEffect(() => {
    // Fetch departments from API
    setLoader(true);
    axios.get(API.getDepartmentData)
      .then((response) => {
        console.log("Departments fetched:", response.data);
        setDepartments(response.data);
      }).catch((error) => {
        console.error("Error fetching departments:", error);
      }).finally(() => {
        setLoader(false);
      });

    if(arg.edit){
      const {user} = arg;
      setName(user.name);
      setEmail(user.email);
      setGroup(user.groups[0].id);
      setManager(user.manager);
      setImageSource(user.photo);
      setUsername(user.username);
      setLevel(user.level);
      setProject(user.project);
      setManagerview(user.managerView);
      setIsFacilitator(user.facilitator || false);
      setIsCILead(user.cilead || false);
    }
  }, [])
  
  
  const handleClose = () => {
    setShow(false);
    arg.handler();
  }
  const handleShow = () => setShow(true);
  //Edit user
  const editUser =()=>{
    setShow(false);
    setLoader(true);
    const formData = new FormData();
    formData.append("id",arg.user.id)
    formData.append("name", name );
    formData.append("username", username);
    formData.append("password", username);
    formData.append("roles",['EMPLOYEE'] );
    formData.append("email", email);
    formData.append("manager", manager);
    formData.append("level", level);
    formData.append("project", project);
    formData.append("managerView", managerView);
    formData.append("facilitator", isFacilitator);
    formData.append("cilead", isCILead);
    if(profileImage.current){
      formData.append("photo", profileImage.current);
    }
    formData.append("groups",[group]);
    
    axios.post(API.editUser, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((resp)=>{
      if(resp){
        // setToastToggle(true);
        toast.success('User edited successfully.');
      }else{
        //handle error
        // setErrorToggle(true);
        toast.error('Failed to edit user.');
      }
      
    }).catch((ex)=>{
      // setErrorToggle(true);
      toast.error('An error occurred while editing user.');
    }).finally(()=>{
      setTimeout(() => {
        setLoader(false);
        //refresh the user list
        arg.callback();
      }, 1000);
    })
  }
  //Add user
  const saveUser=()=>{

    setShow(false);
    setLoader(true);
    const formData = new FormData();
    formData.append("name", name );
    formData.append("username", username);
    formData.append("password", username);
    formData.append("roles",['EMPLOYEE'] );
    formData.append("email", email);
    formData.append("photo", profileImage.current);
    formData.append("groups",[group]);
    formData.append("manager", manager);
    formData.append("level", level);
    formData.append("project", project);
    formData.append("managerView", managerView);
    formData.append("facilitator", isFacilitator);
    formData.append("cilead", isCILead);
    axios.post(API.addUser, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((resp)=>{
      if(resp){
        console.log("User added successfully", resp);
        // setToastToggle(true);
        toast.success('User added successfully.');
      }else{
        //handle error
        // setErrorToggle(true);
        toast.error('Failed to add user.');
      }
      
    }).catch((ex)=>{
      // setErrorToggle(true);
      toast.error('An error occurred while adding user.');
    }).finally(()=>{
      setTimeout(() => {
        setLoader(false);
        //refresh the user list
        arg.callback();
      }, 1000);
    })
    
  }
  const loadImage = (event) =>{
    profileImage.current = event.target.files[0];
    setImageSource(URL.createObjectURL(event.target.files[0]));
  }
  
  return (
    <>
    <Loader loading={loader}></Loader>
    {toastToggle ? <ToastComp case='add-user' handler={()=>{setToastToggle(false)}}/> : ""}
    {errorToggle ? <ToastComp case='error' handler={()=>{setErrorToggle(false)}}/> : ""}
    <Modal show={show} onHide={handleClose}  backdrop="static" keyboard={false}>
    <Modal.Header>
    <Modal.Title>{arg.edit ? "Edit User" : "Add New User"}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
    <Form>
    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
    <Form.Label>Name</Form.Label>
    <Form.Control
    type="text" value={name} autoFocus onChange={(event)=>setName(event.target.value)} />
    </Form.Group>
    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
    <Form.Label>Employee ID</Form.Label>
    <Form.Control
    type="text" value={username}  onChange={(event)=>setUsername(event.target.value)} />
    </Form.Group>
    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
    <Form.Label>Email</Form.Label>
    <Form.Control type="email" value={email}  onChange={(event)=>setEmail(event.target.value)} />
    </Form.Group>
    <Form.Group
    className="mb-3"
    >
    <Form.Label>Department</Form.Label>
    <select className='form-control' value={group} onChange={(e)=>setGroup(e.target.value)}>
    <option></option>
    {
      departments.map((dep)=>{
        return(
          <option  key={dep.id} value={dep.id}>{dep.name}</option>
          )
        })
      }
      </select>
      </Form.Group>
      <Form.Group className="mb-3">
      <Form.Label>Manager</Form.Label>
      <select className='form-control' value={manager} onChange={(e)=>setManager(e.target.value)}>
      <option></option>
      { (arg.userlist) && 
        arg.userlist.map((manager)=>{
          return(
            <option  key={manager.id} value={manager.id}>{manager.name}</option>
            )
          })
        }
        </select>
        </Form.Group>
      <Form.Group className="mb-3">
      <Form.Label>Level</Form.Label>
      <select className='form-control' value={level} onChange={(e)=>setLevel(e.target.value)}>
      <option></option>
      { (levelData) && 
        levelData.map((level)=>{
          return(
            <option  key={level.id} value={level.id}>{level.value}</option>
            )
          })
        }
        </select>
        </Form.Group>
      
      <Form.Group className="mb-3">
      <Form.Label>Project</Form.Label>
      <select className='form-control' value={project} onChange={(e)=>setProject(e.target.value)}>
      <option></option>
      { (projectData) && 
        projectData.map((project)=>{
          return(
            <option  key={project.id} value={project.id}>{project.value}</option>
            )
          })
        }
        </select>
        </Form.Group>

        <Form.Group className="mb-3">
       {/* <Form.Label>Enable Manager Dashboard</Form.Label> */}
       <Form.Check  type='checkbox' checked={managerView}
        value={managerView}  onClick={(event)=>{setManagerview(event.target.checked)}}
        label='Enable Manager Dashboard' />
        </Form.Group>

        <div className="border rounded p-3 mb-3">
        <Form.Label className="mb-2 fw-bold">Ibtikar Details</Form.Label>
        <div className="d-flex gap-4">
        <Form.Check  type='checkbox' checked={isFacilitator}
         value={isFacilitator}  onClick={(event)=>{setIsFacilitator(event.target.checked)}}
         label='Is Facilitator ?' />

        <Form.Check  type='checkbox' checked={isCILead}
         value={isCILead}  onClick={(event)=>{setIsCILead(event.target.checked)}}
         label='Is CI Lead ?' />
        </div>
        </div>

        <Form.Group className="mb-3">
        <Form.Label>Upload Photo</Form.Label>
        <Form.Control type="file" className='form-control' accept="image/png, image/jpeg" onChange={(event)=>loadImage(event)} />
        <img width="100" height="100" src={imageSource}/>
        </Form.Group>
        </Form>
        </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
        CANCEL
        </Button>
        {
          arg.edit ? <Button variant="primary" onClick={editUser}>
          EDIT
          </Button> :
          <Button variant="primary" onClick={saveUser}>
          SAVE
          </Button>
        }
        
        
        </Modal.Footer>
        </Modal>
        </>
        );
      }
      
      export default AddUser;
      
